import { appConfig } from "@quest/appConfig";
import axios from "axios";

class KeycloakClientService {
  async getKeycloakClient(slug: string) {
    const response = await axios.get(
      `${appConfig.apiUrl}/api/v1/tenant/by-slug/${slug}`
    );
    return response.data;
  }
}

export const keycloakClientService = new KeycloakClientService();
